// // import { useState } from "react";
// // import { Link } from "react-router-dom";
// // import { motion, AnimatePresence } from "framer-motion";

// // // -- Constants/Assets (replace as needed) --
// // const HERO_IMAGE =
// //   "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80";
// // const CLIENT_IMAGES = [
// //   "https://randomuser.me/api/portraits/men/76.jpg",
// //   "https://randomuser.me/api/portraits/women/65.jpg",
// //   "https://randomuser.me/api/portraits/men/29.jpg",
// //   "https://randomuser.me/api/portraits/women/44.jpg",
// //   "https://randomuser.me/api/portraits/men/28.jpg",
// // ];
// // const TEAM_IMAGES = [
// //   "https://randomuser.me/api/portraits/men/33.jpg",
// //   "https://randomuser.me/api/portraits/women/31.jpg",
// //   "https://randomuser.me/api/portraits/men/20.jpg",
// // ];
// // const TESTIMONIAL_IMAGES = [
// //   "https://randomuser.me/api/portraits/men/13.jpg",
// //   "https://randomuser.me/api/portraits/women/12.jpg",
// // ];

// // // -- Helper: Animated count up --
// // const CountUp = ({ end, prefix = "", duration = 1.0 }) => {
// //   const [val, setVal] = useState(0);
// //   useState(() => {
// //     let start = 0,
// //       curFrame = 0;
// //     const fps = 30,
// //       totalFrames = duration * fps;
// //     const endNum =
// //       typeof end === "string" ? Number(end.replace(/[^0-9]/g, "")) : end;
// //     const inc = endNum / totalFrames;
// //     const interval = setInterval(() => {
// //       curFrame += 1;
// //       start += inc;
// //       if (curFrame >= totalFrames) {
// //         setVal(end);
// //         clearInterval(interval);
// //       } else
// //         setVal(prefix + Math.floor(start) + (end.includes("k") ? "k+" : "+"));
// //     }, 1000 / fps);
// //     return () => clearInterval(interval);
// //   }, []);
// //   return <span>{val}</span>;
// // };

// // // --- Data arrays ---
// // const stats = [
// //   { value: "7k+", label: "Leads Generated", trend: "↑18% YoY" },
// //   { value: "1M+", label: "Data Records", trend: "99% Accuracy" },
// //   { value: "300+", label: "Happy Clients", trend: "95% Retention" },
// //   { value: "12+", label: "Years Experience", trend: "Since 2020" },
// // ];

// // const services = [
// //   {
// //     title: "Telecalling",
// //     icon: "📞",
// //     path: "/telecallingservices",
// //     description:
// //       "Targeted campaigns in English, Hindi, Tamil & regional languages.",
// //     bullets: [
// //       "Personalized scripts & follow-ups",
// //       "B2B & B2C vertical dialing",
// //       "Voice & IVR analytics dashboard",
// //       "Multilingual & regional specialization",
// //       "Strict GDPR/DPDP compliance",
// //     ],
// //   },
// //   {
// //     title: "Lead Generation",
// //     icon: "🚀",
// //     path: "/leadgenration",
// //     description:
// //       "Blending local insights & digital for superior Indian conversion.",
// //     bullets: [
// //       "Custom /MCA verified prospect lists",
// //       "Outbound, digital & referral campaigns",
// //       "Decision-maker targeting via digital tools",
// //       "High-intent inbound lead management",
// //       "Conversion optimization & reporting",
// //     ],
// //   },
// //   {
// //     title: "Data Build",
// //     icon: "📊",
// //     path: "/dataBuildservices",
// //     description:
// //       "Enrich business lists with verified KYC,  & company metadata.",
// //     bullets: [
// //       "Dual-verified B2B datasets by vertical",
// //       "Technographics & firmographics data",
// //       "Automated deduplication/cleansing",
// //       "Seamless CRM/data warehouse integration",
// //       "Full DPDP, GDPR, RBI overlays",
// //     ],
// //   },
// //   {
// //     title: "Customer Support",
// //     icon: "👥",
// //     path: "/customersupportservices",
// //     description:
// //       "24/7 & multilingual—serving PAN India businesses across time zones.",
// //     bullets: [
// //       "Omnichannel (voice, chat, WhatsApp, email)",
// //       "Flexible coverage—business hours to 24/7",
// //       "Customer CSAT/NPS dashboards",
// //       "Industry-customized response flows",
// //       "Rapid deployment, best-in-class training",
// //     ],
// //   },
// //   {
// //     title: "Market Research",
// //     icon: "📋",
// //     path: "/Webinarregistrationservices",
// //     description: "On-ground and online surveys, data-driven strategy.",
// //     bullets: [
// //       "Digital/offline survey management",
// //       "Analytics by sector & region",
// //       "Focus group & behavioral studies",
// //       "End-to-end data-to-report delivery",
// //     ],
// //   },
// // ];

// // const clients = [
// //   { name: "Bajaj Finserv", logo: CLIENT_IMAGES[0] },
// //   { name: "ICICI Bank", logo: CLIENT_IMAGES[1] },
// //   { name: "Tata Consultancy", logo: CLIENT_IMAGES[2] },
// //   { name: "Infosys BPM", logo: CLIENT_IMAGES[3] },
// //   { name: "Byju's", logo: CLIENT_IMAGES[4] },
// // ];

// // const features = [
// //   {
// //     title: "Bharat Expertise",
// //     description:
// //       "Decades in Indian B2B sales enablement & database compliance.",
// //   },
// //   {
// //     title: "Data Accuracy",
// //     description: "Dual-verified, -checked info, 99%+ accuracy guaranteed.",
// //   },
// //   {
// //     title: "Regional Coverage",
// //     description:
// //       "Urban & rural coverage from metros to Tier-II/III Indian cities.",
// //   },
// //   {
// //     title: "Compliance",
// //     description:
// //       "STRICT privacy - fully adheres to India's DPDP, GDPR, and RBI regs.",
// //   },
// // ];

// // const testimonials = [
// //   {
// //     quote:
// //       "Augere's multilingual telecalling helped us tap SME clients across Pune & Bengaluru. Fantastic reliability and reporting.",
// //     name: "Amit Sharma",
// //     role: "Head of Business, Bajaj",
// //     photo: TESTIMONIAL_IMAGES[0],
// //   },
// //   {
// //     quote:
// //       "We saw conversion rates improve 50%. The localized lead lists are best in the market.",
// //     name: "Priya Singh",
// //     role: "Sales Ops, TCS",
// //     photo: TESTIMONIAL_IMAGES[1],
// //   },
// // ];

// // const teComplex = [
// //   {
// //     name: "AI Data Tools",
// //     desc: "Smart matching & enrichment, built for Indian business formats.",
// //     icon: "🤖",
// //   },
// //   {
// //     name: "Cloud Secure",
// //     desc: "All India AWS Data Regions, instant scalable access.",
// //     icon: "☁️",
// //   },
// //   {
// //     name: "CRM Integration",
// //     desc: "Seamless with Zoho, Freshsales, Salesforce, Hubspot.",
// //     icon: "🔗",
// //   },
// //   {
// //     name: "WhatsApp APIs",
// //     desc: "Outreach & support directly via WhatsApp Business.",
// //     icon: "📱",
// //   },
// // ];

// // const team = [
// //   {
// //     name: "Rohan Malhotra",
// //     role: "Founder & CEO",
// //     about: "Visionary with 16yrs in Indian SaaS & BFSI.",
// //     photo: TEAM_IMAGES[0],
// //   },
// //   {
// //     name: "Priya Venkatesh",
// //     role: "Head - Data Ops",
// //     about: "Leads cross-India QA & analytics. IIM alum.",
// //     photo: TEAM_IMAGES[1],
// //   },
// //   {
// //     name: "Anil Kumar",
// //     role: "Chief Growth Officer",
// //     about: "Spearheads client campaigns, ex-Zoho.",
// //     photo: TEAM_IMAGES[2],
// //   },
// // ];

// // const faq = [
// //   {
// //     question: "What industries do you serve?",
// //     answer:
// //       "We serve BFSI, SaaS, EdTech, D2C, Manufacturing, Healthcare, and more—covering both startups and large enterprises across India.",
// //   },
// //   {
// //     question: "How accurate is your data?",
// //     answer:
// //       "We guarantee 99%+ accuracy due to dual-checks, /MCA validation, and regular refreshes. We also honor opt-outs as per DPDP.",
// //   },
// //   {
// //     question: "Can you support operations in regional languages?",
// //     answer:
// //       "Absolutely! Our teams operate in Hindi, Tamil, Telugu, Bengali, Marathi, and more. Local language support is our specialty.",
// //   },
// //   {
// //     question: "Do you handle compliance and data privacy?",
// //     answer:
// //       "Yes. We're fully compliant with India's DPDP Act, RBI, and GDPR, and maintain detailed audit trails for all datasets.",
// //   },
// //   {
// //     question: "What is the onboarding process like?",
// //     answer:
// //       "After an initial consult, you get a custom plan and demo. We onboard and integrate within 3–10 days depending on scale.",
// //   },
// // ];

// // const fadeIn = {
// //   hidden: { opacity: 0, y: 38 },
// //   visible: { opacity: 1, y: 0, transition: { duration: 0.77 } },
// // };

// // const Home = () => {
// //   const [testimonialIdx, setTestimonialIdx] = useState(0);
// //   const [openFaq, setOpenFaq] = useState(null);
// //   const [modalSvcIdx, setModalSvcIdx] = useState(null);

// //   return (
// //     <div className="font-sans text-gray-800 bg-gradient-to-br from-blue-900 to-indigo-950 min-h-screen">
// //       {/* HERO SECTION */}
// //       <section className="relative min-h-[90vh] flex items-center justify-center bg-black">
// //         <img
// //           src={HERO_IMAGE}
// //           alt="Mumbai Skyline"
// //           className="absolute inset-0 w-full h-full object-cover object-center z-0 opacity-80"
// //           style={{ filter: "blur(0px) brightness(0.74)" }}
// //         />
// //         <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/70 via-indigo-900/60 to-yellow-100/80 z-0"></div>
// //         <motion.div
// //           initial={{ opacity: 0, y: 45 }}
// //           animate={{ opacity: 1, y: 0 }}
// //           transition={{ duration: 1 }}
// //           className="relative z-20 w-full max-w-2xl bg-white/10 backdrop-blur-2xl px-10 py-16 rounded-3xl shadow-2xl flex flex-col items-center mx-4"
// //         >
// //           <span className="bg-white/30 px-6 py-2 rounded-full text-base font-semibold tracking-wide text-white border border-white/30 shadow mb-4 italic">
// //             Leading India's Data-Driven Sales since 2020
// //           </span>
// //           <h1 className="text-5xl font-extrabold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-white to-blue-200 drop-shadow mb-4 text-center">
// //             <span className="text-yellow-300">India’s Boldest</span> <br />
// //             B2B Growth Engine
// //           </h1>
// //           <p className="text-lg md:text-xl text-gray-100/90 mb-9 font-medium text-center max-w-2xl">
// //             Unlock the power of{" "}
// //             <span className="text-yellow-300 font-bold">Precision Data</span> &{" "}
// //             <span className="text-blue-100 font-bold">
// //               Authentic Connections
// //             </span>
// //             —across every Indian region.
// //           </p>
// //           <div className="flex flex-wrap gap-6 justify-center">
// //             <Link
// //               to="/get-quote"
// //               className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 rounded-lg px-8 py-4 font-bold shadow-xl ring-2 ring-yellow-100 hover:ring-yellow-300 focus:outline-none transition text-lg"
// //             >
// //               Get a Quote
// //             </Link>
// //             <Link
// //               to="/about"
// //               className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white/10 transition text-lg"
// //             >
// //               Learn More
// //             </Link>
// //           </div>
// //         </motion.div>
// //       </section>

// //       {/* Stats */}
// //       <section className="py-14 bg-white/0 max-w-6xl mx-auto px-4">
// //         <div className="grid grid-cols-2 md:grid-cols-4 gap-7">
// //           {stats.map((stat) => (
// //             <motion.div
// //               key={stat.label}
// //               initial="hidden"
// //               whileInView="visible"
// //               viewport={{ once: true }}
// //               variants={fadeIn}
// //               className="bg-white/30 backdrop-blur-lg rounded-3xl p-10 text-center shadow-md transition hover:-translate-y-1 hover:shadow-yellow-200 group cursor-pointer"
// //             >
// //               <span className="text-4xl font-extrabold text-yellow-400">
// //                 <CountUp end={stat.value} />
// //               </span>
// //               <div className="text-xs uppercase tracking-widest mt-1 group-hover:text-blue-700">
// //                 {stat.label}
// //               </div>
// //               <div className="text-[11px] mt-1 text-blue-600 font-semibold">
// //                 {stat.trend}
// //               </div>
// //             </motion.div>
// //           ))}
// //         </div>
// //       </section>

// //       {/* About */}
// //       <section className="py-24 bg-white">
// //         <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
// //           <motion.div
// //             initial={{ opacity: 0, x: -30 }}
// //             whileInView={{ opacity: 1, x: 0 }}
// //             transition={{ duration: 0.7 }}
// //             viewport={{ once: true }}
// //           >
// //             <h2 className="text-3xl font-bold text-blue-900 mb-4">
// //               About Augere Strategies
// //             </h2>
// //             <p className="text-lg text-gray-700 mb-5">
// //               Augere Strategies  is India’s leading provider of{" "}
// //               <strong>
// //                 data-driven lead generation, telecalling, and market research
// //               </strong>{" "}
// //               since 2020. Our Mumbai HQ backs brands PAN India—from funded tech
// //               pioneers to Fortune 500 MNCs—delivering reliable, compliance-ready
// //               solutions that convert insight to revenue.
// //             </p>
// //             <ul className="space-y-3">
// //               <li className="flex items-start">
// //                 <svg
// //                   className="w-5 h-5 text-yellow-500 mt-1 mr-2"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     d="M5 13l4 4L19 7"
// //                   />
// //                 </svg>
// //                 500M+ pan-India business records
// //               </li>
// //               <li className="flex items-start">
// //                 <svg
// //                   className="w-5 h-5 text-yellow-500 mt-1 mr-2"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     d="M5 13l4 4L19 7"
// //                   />
// //                 </svg>
// //                 Awarded top B2B telecalling provider, 2024
// //               </li>
// //               <li className="flex items-start">
// //                 <svg
// //                   className="w-5 h-5 text-yellow-500 mt-1 mr-2"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     d="M5 13l4 4L19 7"
// //                   />
// //                 </svg>
// //                 12+ years in B2B sales intelligence
// //               </li>
// //             </ul>
// //             <Link
// //               to="/about"
// //               className="inline-block mt-7 text-blue-700 font-semibold hover:text-yellow-500 hover:underline transition"
// //             >
// //               Learn more About Us &rarr;
// //             </Link>
// //           </motion.div>
// //           <motion.div
// //             initial={{ opacity: 0, x: 30 }}
// //             whileInView={{ opacity: 1, x: 0 }}
// //             transition={{ duration: 0.7 }}
// //             viewport={{ once: true }}
// //             className="rounded-3xl shadow-xl overflow-hidden"
// //           >
// //             <img
// //               src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?auto=format&fit=crop&w=600&q=80"
// //               alt="Augere team at work"
// //               className="w-full object-cover max-h-[380px] min-h-[220px]"
// //             />
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* Company Overview */}
// //       <section className="py-20 bg-white">
// //         <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">
// //           <motion.div
// //             initial={{ opacity: 0, x: -34 }}
// //             whileInView={{ opacity: 1, x: 0 }}
// //             transition={{ duration: 0.7 }}
// //             viewport={{ once: true }}
// //           >
// //             <img
// //               src="https://images.unsplash.com/photo-1482062364825-616fd23b8fc1?auto=format&fit=crop&w=600&q=80"
// //               alt="Company workspace"
// //               className="rounded-3xl shadow-lg object-cover max-h-[330px]"
// //             />
// //           </motion.div>
// //           <motion.div
// //             initial={{ opacity: 0, x: 34 }}
// //             whileInView={{ opacity: 1, x: 0 }}
// //             transition={{ duration: 0.7 }}
// //             viewport={{ once: true }}
// //           >
// //             <h2 className="text-3xl font-bold text-yellow-700 mb-4">
// //               Our Company at a Glance
// //             </h2>
// //             <p className="text-lg text-gray-700 mb-5">
// //               Born in Mumbai, we now operate across all Indian metros and
// //               Tier-II/III cities, with support and sales teams in New Delhi,
// //               Bangalore, and Pune. Our mission:{" "}
// //               <span className="text-blue-800 font-semibold">
// //                 “Turning raw data into revenue for every Indian business.”
// //               </span>
// //             </p>
// //             <div className="grid grid-cols-2 gap-4 mt-6">
// //               <div>
// //                 <div className="text-3xl font-bold text-blue-600">300+</div>
// //                 <div className="text-base text-gray-600">Active Clients</div>
// //               </div>
// //               <div>
// //                 <div className="text-3xl font-bold text-blue-600">15+</div>
// //                 <div className="text-base text-gray-600">States Covered</div>
// //               </div>
// //             </div>
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* --- Services with Modal --- */}
// //       <section className="py-20 bg-gradient-to-br from-slate-100 via-white to-yellow-50">
// //         <div className="max-w-7xl mx-auto px-6">
// //           <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center">
// //             Our Key Services
// //           </h2>
// //           <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
// //             {services.map((service, idx) => (
// //               <motion.div
// //                 key={service.title}
// //                 initial={{ opacity: 0, y: 28 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 transition={{ delay: idx * 0.1, duration: 0.48 }}
// //                 viewport={{ once: true }}
// //                 whileHover={{ scale: 1.07, y: -4 }}
// //                 className="bg-white/90 border border-yellow-100 rounded-2xl flex flex-col p-8 items-center text-center shadow hover:shadow-lg transition-all cursor-pointer"
// //               >
// //                 <div className="mb-2 text-5xl">{service.icon}</div>
// //                 <h3 className="text-lg font-extrabold mb-2 text-yellow-700">
// //                   {service.title}
// //                 </h3>
// //                 <p className="text-gray-700/90 mb-4">{service.description}</p>
// //                 <button
// //                   className="text-blue-500 font-semibold hover:underline transition"
// //                   onClick={() => setModalSvcIdx(idx)}
// //                 >
// //                   View Service
// //                 </button>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>

// //         {/* Modal */}
// //         <AnimatePresence>
// //           {modalSvcIdx !== null && (
// //             <motion.div
// //               className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
// //               initial="hidden"
// //               animate="visible"
// //               exit="hidden"
// //               variants={{
// //                 visible: { opacity: 1, pointerEvents: "auto" },
// //                 hidden: {
// //                   opacity: 0,
// //                   pointerEvents: "none",
// //                   transition: { delay: 0.34 },
// //                 },
// //               }}
// //               onClick={() => setModalSvcIdx(null)}
// //             >
// //               <motion.div
// //                 className="bg-white w-full max-w-lg rounded-3xl shadow-2xl p-9 relative mx-4"
// //                 initial="hidden"
// //                 animate="visible"
// //                 exit="hidden"
// //                 variants={{
// //                   hidden: { opacity: 0, y: 70, scale: 0.96 },
// //                   visible: {
// //                     opacity: 1,
// //                     y: 0,
// //                     scale: 1,
// //                     transition: { duration: 0.31, ease: [0.4, 0, 0.2, 1] },
// //                   },
// //                 }}
// //                 onClick={(e) => e.stopPropagation()}
// //               >
// //                 <button
// //                   className="absolute top-4 right-5 text-2xl text-blue-700 font-extrabold hover:text-yellow-600 transition"
// //                   onClick={() => setModalSvcIdx(null)}
// //                   aria-label="Close"
// //                 >
// //                   &times;
// //                 </button>
// //                 <div className="flex items-center gap-4 mb-4">
// //                   <span className="text-3xl">{services[modalSvcIdx].icon}</span>
// //                   <h3 className="text-2xl font-bold text-blue-900">
// //                     {services[modalSvcIdx].title}
// //                   </h3>
// //                 </div>
// //                 <p className="text-gray-700 mb-5">
// //                   {services[modalSvcIdx].description}
// //                 </p>
// //                 <ul className="mb-7 space-y-2">
// //                   {services[modalSvcIdx].bullets.map((item, i) => (
// //                     <li key={i} className="flex items-start text-base">
// //                       <svg
// //                         className="mt-1 mr-2 w-5 h-5 text-yellow-500"
// //                         fill="none"
// //                         viewBox="0 0 24 24"
// //                         stroke="currentColor"
// //                       >
// //                         <path
// //                           strokeLinecap="round"
// //                           strokeLinejoin="round"
// //                           d="M5 13l4 4L19 7"
// //                         />
// //                       </svg>
// //                       <span>{item}</span>
// //                     </li>
// //                   ))}
// //                 </ul>
// //                 <div className="flex gap-4 mt-8">
// //                   <Link
// //                     to={services[modalSvcIdx].path}
// //                     className="px-5 py-2 rounded-md bg-blue-600 text-white font-bold hover:bg-blue-700 transition"
// //                   >
// //                     Full Service Page
// //                   </Link>
// //                   <button
// //                     onClick={() => setModalSvcIdx(null)}
// //                     className="px-4 py-2 rounded-md border border-yellow-500 text-yellow-600 font-bold hover:bg-yellow-50 transition"
// //                   >
// //                     Close
// //                   </button>
// //                 </div>
// //               </motion.div>
// //             </motion.div>
// //           )}
// //         </AnimatePresence>
// //       </section>

// //       {/* CLIENTS */}
// //       <section className="bg-yellow-50 py-10">
// //         <div className="max-w-5xl mx-auto px-6">
// //           <h3 className="text-xl font-bold mb-7 text-center text-yellow-800">
// //             Trusted by Indian Enterprises & Startups
// //           </h3>
// //           <div className="flex flex-wrap justify-center gap-7">
// //             {clients.map((client, i) => (
// //               <motion.div
// //                 key={client.name}
// //                 initial={{ opacity: 0, scale: 0.9 }}
// //                 whileInView={{ opacity: 1, scale: 1 }}
// //                 transition={{ delay: i * 0.07 }}
// //                 viewport={{ once: true }}
// //                 className="flex flex-col items-center"
// //               >
// //                 <img
// //                   src={client.logo}
// //                   alt={client.name}
// //                   className="rounded-full w-20 h-20 border-4 border-yellow-200 shadow mb-2"
// //                 />
// //                 <div className="text-sm font-bold text-blue-700">
// //                   {client.name}
// //                 </div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* FEATURES ("Why Us") */}
// //       <section className="py-16 bg-white">
// //         <div className="max-w-7xl mx-auto px-6 text-center mb-11">
// //           <h2 className="text-3xl font-bold mb-3 text-yellow-700">
// //             Why Indian Businesses Choose Us
// //           </h2>
// //           <p className="text-gray-600 max-w-2xl mx-auto">
// //             India-ready{" "}
// //             <span className="text-yellow-600">
// //               platforms, expertise, compliance
// //             </span>{" "}
// //             — with heart and hustle.
// //           </p>
// //         </div>
// //         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 px-6">
// //           {features.map((f, i) => (
// //             <motion.div
// //               key={f.title}
// //               initial={{ opacity: 0, y: 40 }}
// //               whileInView={{ opacity: 1, y: 0 }}
// //               viewport={{ once: true }}
// //               transition={{ delay: i * 0.1, duration: 0.5 }}
// //               className="bg-yellow-50 p-8 rounded-xl shadow hover:shadow-lg transition"
// //             >
// //               <div className="text-yellow-700 font-bold text-lg mb-2">
// //                 {String(i + 1).padStart(2, "0")}.
// //               </div>
// //               <h3 className="text-xl font-bold mb-3 text-blue-900">
// //                 {f.title}
// //               </h3>
// //               <p className="text-gray-600">{f.description}</p>
// //             </motion.div>
// //           ))}
// //         </div>
// //       </section>

// //       {/* TECHNOLOGIES */}
// //       <section className="py-14 bg-gradient-to-r from-yellow-50 via-white to-blue-50">
// //         <div className="max-w-6xl mx-auto px-6">
// //           <h2 className="text-3xl font-bold text-yellow-800 mb-7 text-center">
// //             Empowered by Indian-Ready Technologies
// //           </h2>
// //           <div className="grid md:grid-cols-4 gap-7">
// //             {teComplex.map((t, i) => (
// //               <motion.div
// //                 key={t.name}
// //                 initial={{ opacity: 0, y: 30 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 transition={{ delay: i * 0.11 }}
// //                 viewport={{ once: true }}
// //                 className="rounded-lg bg-white p-7 shadow-sm flex flex-col items-center hover:bg-yellow-50 transition"
// //               >
// //                 <div className="text-3xl mb-2">{t.icon}</div>
// //                 <div className="text-lg font-bold mb-1 text-yellow-700">
// //                   {t.name}
// //                 </div>
// //                 <div className="text-sm text-gray-600">{t.desc}</div>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* TESTIMONIALS */}
// //       <section className="py-20 bg-blue-50">
// //         <div className="max-w-5xl mx-auto px-6 text-center">
// //           <h2 className="text-3xl font-bold text-yellow-800 mb-10">
// //             Hear From Indian Entrepreneurs
// //           </h2>
// //           <div className="relative">
// //             <AnimatePresence mode="wait">
// //               <motion.div
// //                 key={testimonialIdx}
// //                 initial={{ opacity: 0, x: -60 }}
// //                 animate={{ opacity: 1, x: 0 }}
// //                 exit={{ opacity: 0, x: 50 }}
// //                 transition={{ duration: 0.59 }}
// //                 className="flex flex-col items-center"
// //               >
// //                 <img
// //                   src={testimonials[testimonialIdx].photo}
// //                   alt={testimonials[testimonialIdx].name}
// //                   className="w-20 h-20 rounded-full mx-auto mb-5 border-4 border-yellow-200 shadow"
// //                 />
// //                 <blockquote className="italic text-lg text-blue-800 mb-2 max-w-2xl">
// //                   "{testimonials[testimonialIdx].quote}"
// //                 </blockquote>
// //                 <strong className="block text-yellow-800">
// //                   {testimonials[testimonialIdx].name}
// //                 </strong>
// //                 <span className="text-blue-700 text-sm">
// //                   {testimonials[testimonialIdx].role}
// //                 </span>
// //               </motion.div>
// //             </AnimatePresence>
// //             <div className="mt-6 flex justify-center gap-3">
// //               {[0, 1].map((i) => (
// //                 <button
// //                   key={i}
// //                   onClick={() => setTestimonialIdx(i)}
// //                   className={`h-3 w-3 rounded-full border border-yellow-400 ${
// //                     testimonialIdx === i ? "bg-yellow-500" : "bg-white"
// //                   }`}
// //                 ></button>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* TEAM */}
// //       <section className="py-14 bg-gradient-to-br from-yellow-50 via-blue-50 to-white">
// //         <div className="max-w-6xl mx-auto px-6">
// //           <h2 className="text-3xl font-bold mb-8 text-yellow-800 text-center">
// //             Meet Our Leadership
// //           </h2>
// //           <div className="flex flex-wrap justify-center gap-9">
// //             {team.map((member, i) => (
// //               <motion.div
// //                 key={member.name}
// //                 initial={{ opacity: 0, y: 26 }}
// //                 whileInView={{ opacity: 1, y: 0 }}
// //                 viewport={{ once: true }}
// //                 transition={{ delay: i * 0.13 }}
// //                 className="bg-white rounded-2xl shadow p-7 flex flex-col items-center w-80"
// //               >
// //                 <img
// //                   src={member.photo}
// //                   alt={member.name}
// //                   className="mb-3 w-20 h-20 rounded-full border-4 border-yellow-100"
// //                 />
// //                 <h4 className="text-blue-900 font-bold text-xl">
// //                   {member.name}
// //                 </h4>
// //                 <span className="text-yellow-700">{member.role}</span>
// //                 <p className="mt-3 text-gray-600 text-sm">{member.about}</p>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* FAQ */}
// //       <section className="py-20 bg-gradient-to-br from-blue-50 via-yellow-50 to-white">
// //         <div className="max-w-4xl mx-auto px-6">
// //           <h2 className="text-3xl font-bold text-blue-900 mb-7 text-center">
// //             Frequently Asked Questions
// //           </h2>
// //           <div className="space-y-5">
// //             {faq.map((item, i) => (
// //               <div
// //                 key={i}
// //                 className={`border border-gray-200 bg-white rounded-lg shadow px-6 py-5 cursor-pointer transition group ${
// //                   openFaq === i
// //                     ? "ring-2 ring-yellow-400"
// //                     : "hover:ring-1 hover:ring-yellow-200"
// //                 }`}
// //                 onClick={() => setOpenFaq(openFaq === i ? null : i)}
// //                 tabIndex={0}
// //                 aria-expanded={openFaq === i}
// //                 onKeyDown={(e) => {
// //                   if (e.key === "Enter" || e.key === " ")
// //                     setOpenFaq(openFaq === i ? null : i);
// //                 }}
// //               >
// //                 <div className="flex items-center justify-between">
// //                   <span className="font-semibold text-lg text-blue-900">
// //                     {item.question}
// //                   </span>
// //                   <span className="ml-3 text-2xl text-yellow-500 transition-transform duration-200">
// //                     {openFaq === i ? "-" : "+"}
// //                   </span>
// //                 </div>
// //                 <AnimatePresence initial={false}>
// //                   {openFaq === i && (
// //                     <motion.div
// //                       key={`faq-answer-${i}`}
// //                       initial={{ height: 0, opacity: 0 }}
// //                       animate={{ height: "auto", opacity: 1 }}
// //                       exit={{ height: 0, opacity: 0 }}
// //                       transition={{ duration: 0.27, ease: "easeInOut" }}
// //                       className="overflow-hidden mt-3"
// //                     >
// //                       <div className="text-gray-700 text-base">
// //                         {item.answer}
// //                       </div>
// //                     </motion.div>
// //                   )}
// //                 </AnimatePresence>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* FINAL CTA */}
// //       <section className="py-20 bg-gradient-to-r from-yellow-400 to-blue-800 text-white">
// //         <div className="max-w-4xl mx-auto px-6 text-center">
// //           <motion.h2
// //             initial={{ opacity: 0, y: 30 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             viewport={{ once: true }}
// //             className="text-3xl font-bold mb-6"
// //           >
// //             Accelerate Your Business with Us
// //           </motion.h2>
// //           <motion.p
// //             initial={{ opacity: 0 }}
// //             whileInView={{ opacity: 1 }}
// //             transition={{ delay: 0.19 }}
// //             viewport={{ once: true }}
// //             className="text-xl mb-8 max-w-2xl mx-auto"
// //           >
// //             Call any time or request your free growth consultation – our experts
// //             in Mumbai, Delhi, and Bengaluru are ready!
// //           </motion.p>
// //           <motion.div
// //             initial={{ opacity: 0, scale: 0.98 }}
// //             whileInView={{ opacity: 1, scale: 1 }}
// //             transition={{ delay: 0.15 }}
// //             className="flex flex-col sm:flex-row gap-4 justify-center"
// //           >
// //             <Link
// //               to="/contact"
// //               className="bg-white text-yellow-700 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition shadow-lg hover:shadow-xl"
// //             >
// //               Contact Us
// //             </Link>
// //             <a
// //               href="tel:+911139876543"
// //               className="border-2 border-white px-8 py-3 rounded-lg font-bold hover:bg-white/10 transition"
// //             >
// //               +91 7021216035/8828357920
// //             </a>
// //           </motion.div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default Home;

// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import CookieBanner from "../components/CookieBanner";

// const HERO_IMAGE =
//   "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80";
// const CLIENT_IMAGES = [
//   "https://randomuser.me/api/portraits/men/76.jpg",
//   "https://randomuser.me/api/portraits/women/65.jpg",
//   "https://randomuser.me/api/portraits/men/29.jpg",
//   "https://randomuser.me/api/portraits/women/44.jpg",
//   "https://randomuser.me/api/portraits/men/28.jpg",
// ];
// const TEAM_IMAGES = [
//   "https://randomuser.me/api/portraits/men/33.jpg",
//   "https://randomuser.me/api/portraits/women/31.jpg",
//   "https://randomuser.me/api/portraits/men/20.jpg",
// ];
// const TESTIMONIAL_IMAGES = [
//   "https://randomuser.me/api/portraits/men/13.jpg",
//   "https://randomuser.me/api/portraits/women/12.jpg",
// ];

// const CountUp = ({ end, prefix = "", duration = 1.0 }) => {
//   const [val, setVal] = useState(0);
//   useState(() => {
//     let start = 0,
//       curFrame = 0;
//     const fps = 30,
//       totalFrames = duration * fps;
//     const endNum =
//       typeof end === "string" ? Number(end.replace(/[^0-9]/g, "")) : end;
//     const inc = endNum / totalFrames;
//     const interval = setInterval(() => {
//       curFrame += 1;
//       start += inc;
//       if (curFrame >= totalFrames) {
//         setVal(end);
//         clearInterval(interval);
//       } else
//         setVal(prefix + Math.floor(start) + (end.includes("k") ? "k+" : "+"));
//     }, 1000 / fps);
//     return () => clearInterval(interval);
//   }, []);
//   return <span>{val}</span>;
// };

// const stats = [
//   { value: "7k+", label: "Leads Generated", trend: "↑18% YoY" },
//   { value: "1M+", label: "Data Records", trend: "99% Accuracy" },
//   { value: "300+", label: "Happy Clients", trend: "95% Retention" },
//   { value: "12+", label: "Years Experience", trend: "Since 2020" },
// ];

// const services = [
//   {
//     title: "Telecalling",
//     icon: "📞",
//     path: "/telecallingservices",
//     description:
//       "Targeted campaigns in English, Hindi, Tamil & regional languages.",
//     bullets: [
//       "Personalized scripts & follow-ups",
//       "B2B & B2C vertical dialing",
//       "Voice & IVR analytics dashboard",
//       "Multilingual & regional specialization",
//       "Strict GDPR/DPDP compliance",
//     ],
//   },
//   {
//     title: "Lead Generation",
//     icon: "🚀",
//     path: "/leadgenration",
//     description:
//       "Blending local insights & digital for superior Indian conversion.",
//     bullets: [
//       "Custom /MCA verified prospect lists",
//       "Outbound, digital & referral campaigns",
//       "Decision-maker targeting via digital tools",
//       "High-intent inbound lead management",
//       "Conversion optimization & reporting",
//     ],
//   },
//   {
//     title: "Data Build",
//     icon: "📊",
//     path: "/dataBuildservices",
//     description:
//       "Enrich business lists with verified KYC,  & company metadata.",
//     bullets: [
//       "Dual-verified B2B datasets by vertical",
//       "Technographics & firmographics data",
//       "Automated deduplication/cleansing",
//       "Seamless CRM/data warehouse integration",
//       "Full DPDP, GDPR, RBI overlays",
//     ],
//   },
//   {
//     title: "Customer Support",
//     icon: "👥",
//     path: "/customersupportservices",
//     description:
//       "24/7 & multilingual—serving PAN India businesses across time zones.",
//     bullets: [
//       "Omnichannel (voice, chat, WhatsApp, email)",
//       "Flexible coverage—business hours to 24/7",
//       "Customer CSAT/NPS dashboards",
//       "Industry-customized response flows",
//       "Rapid deployment, best-in-class training",
//     ],
//   },
//   {
//     title: "Market Research",
//     icon: "📋",
//     path: "/Webinarregistrationservices",
//     description: "On-ground and online surveys, data-driven strategy.",
//     bullets: [
//       "Digital/offline survey management",
//       "Analytics by sector & region",
//       "Focus group & behavioral studies",
//       "End-to-end data-to-report delivery",
//     ],
//   },
// ];

// const clients = [
//   { name: "Bajaj Finserv", logo: CLIENT_IMAGES[0] },
//   { name: "ICICI Bank", logo: CLIENT_IMAGES[1] },
//   { name: "Tata Consultancy", logo: CLIENT_IMAGES[2] },
//   { name: "Infosys BPM", logo: CLIENT_IMAGES[3] },
//   { name: "Byju's", logo: CLIENT_IMAGES[4] },
// ];

// const features = [
//   {
//     title: "Bharat Expertise",
//     description:
//       "Decades in Indian B2B sales enablement & database compliance.",
//   },
//   {
//     title: "Data Accuracy",
//     description: "Dual-verified, -checked info, 99%+ accuracy guaranteed.",
//   },
//   {
//     title: "Regional Coverage",
//     description:
//       "Urban & rural coverage from metros to Tier-II/III Indian cities.",
//   },
//   {
//     title: "Compliance",
//     description:
//       "STRICT privacy - fully adheres to India's DPDP, GDPR, and RBI regs.",
//   },
// ];

// const testimonials = [
//   {
//     quote:
//       "Augere's multilingual telecalling helped us tap SME clients across Pune & Bengaluru. Fantastic reliability and reporting.",
//     name: "Amit Sharma",
//     role: "Head of Business, Bajaj",
//     photo: TESTIMONIAL_IMAGES[0],
//   },
//   {
//     quote:
//       "We saw conversion rates improve 50%. The localized lead lists are best in the market.",
//     name: "Priya Singh",
//     role: "Sales Ops, TCS",
//     photo: TESTIMONIAL_IMAGES[1],
//   },
// ];

// const teComplex = [
//   {
//     name: "AI Data Tools",
//     desc: "Smart matching & enrichment, built for Indian business formats.",
//     icon: "🤖",
//   },
//   {
//     name: "Cloud Secure",
//     desc: "All India AWS Data Regions, instant scalable access.",
//     icon: "☁️",
//   },
//   {
//     name: "CRM Integration",
//     desc: "Seamless with Zoho, Freshsales, Salesforce, Hubspot.",
//     icon: "🔗",
//   },
//   {
//     name: "WhatsApp APIs",
//     desc: "Outreach & support directly via WhatsApp Business.",
//     icon: "📱",
//   },
// ];

// const team = [
//   {
//     name: "Rohan Malhotra",
//     role: "Founder & CEO",
//     about: "Visionary with 16yrs in Indian SaaS & BFSI.",
//     photo: TEAM_IMAGES[0],
//   },
//   {
//     name: "Priya Venkatesh",
//     role: "Head - Data Ops",
//     about: "Leads cross-India QA & analytics. IIM alum.",
//     photo: TEAM_IMAGES[1],
//   },
//   {
//     name: "Anil Kumar",
//     role: "Chief Growth Officer",
//     about: "Spearheads client campaigns, ex-Zoho.",
//     photo: TEAM_IMAGES[2],
//   },
// ];

// const faq = [
//   {
//     question: "What industries do you serve?",
//     answer:
//       "We serve BFSI, SaaS, EdTech, D2C, Manufacturing, Healthcare, and more—covering both startups and large enterprises across India.",
//   },
//   {
//     question: "How accurate is your data?",
//     answer:
//       "We guarantee 99%+ accuracy due to dual-checks, /MCA validation, and regular refreshes. We also honor opt-outs as per DPDP.",
//   },
//   {
//     question: "Can you support operations in regional languages?",
//     answer:
//       "Absolutely! Our teams operate in Hindi, Tamil, Telugu, Bengali, Marathi, and more. Local language support is our specialty.",
//   },
//   {
//     question: "Do you handle compliance and data privacy?",
//     answer:
//       "Yes. We're fully compliant with India's DPDP Act, RBI, and GDPR, and maintain detailed audit trails for all datasets.",
//   },
//   {
//     question: "What is the onboarding process like?",
//     answer:
//       "After an initial consult, you get a custom plan and demo. We onboard and integrate within 3–10 days depending on scale.",
//   },
// ];

// const fadeIn = {
//   hidden: { opacity: 0, y: 38 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.77 } },
// };

// const Home = () => {
//   const [testimonialIdx, setTestimonialIdx] = useState(0);
//   const [openFaq, setOpenFaq] = useState(null);
//   const [modalSvcIdx, setModalSvcIdx] = useState(null);

//   return (
//     <>
//       <div className="font-sans text-gray-800 bg-gradient-to-br from-blue-900 to-indigo-950 min-h-screen">
//         {/* HERO SECTION - Visually Enhanced & Responsive */}
//         <section className="relative min-h-[73vh] md:min-h-[90vh] flex items-center justify-center bg-black overflow-hidden">
//           <img
//             src={HERO_IMAGE}
//             alt="Mumbai Skyline"
//             className="absolute inset-0 w-full h-full object-cover object-center z-0 opacity-80"
//             style={{ filter: "brightness(0.65) blur(2px)" }}
//           />
//           <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/80 via-indigo-900/60 to-yellow-100/80 z-0"></div>
//           <motion.div
//             initial={{ opacity: 0, y: 45 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 1 }}
//             className="relative z-20 w-full max-w-2xl md:max-w-3xl lg:max-w-4xl px-5 md:px-10 py-10 md:py-16 rounded-3xl bg-white/20 backdrop-blur-2xl shadow-2xl border border-white/30 flex flex-col items-center"
//           >
//             {/* Decorative Circle Accent */}
//             <div className="absolute top-8 left-8 w-12 h-12 bg-yellow-200 rounded-full opacity-30 md:opacity-50 blur-xl"></div>
//             <span className="bg-white/40 px-4 md:px-7 py-2 rounded-full text-base md:text-lg font-semibold tracking-wide text-blue-900 border border-white/30 shadow mb-5 text-center italic max-w-xs md:max-w-none">
//               Backed by decades of expertise
//             </span>
//             <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-white to-blue-200 drop-shadow mb-4 md:mb-6 text-center">
//               <span className="inline-block pb-0.5 border-b-4 border-yellow-300">
//                 India’s Boldest
//               </span>
//               <br className="hidden md:block" />
//               Lead Generation & Data Building Team
//             </h1>
//             <p className="text-base sm:text-lg md:text-xl text-gray-100/90 mb-5 md:mb-7 font-medium text-center max-w-2xl">
//               Welcome to{" "}
//               <span className="text-yellow-300 font-bold">
//                 Augere Strategies
//               </span>
//               —your trusted partner for
//               <span className="text-blue-100 font-bold">
//                 {" "}
//                 B2B lead generation
//               </span>{" "}
//               and database solutions. We excel at connecting businesses with key
//               decision-makers.
//             </p>
//             <p className="text-sm sm:text-base md:text-lg text-gray-100/80 mb-7 text-center max-w-3xl">
//               Our mission is to empower{" "}
//               <span className="text-yellow-300 font-semibold">
//                 event organizers, media, IT, publishing, and financial services
//                 companies
//               </span>{" "}
//               with high-quality, accurate, and comprehensive data—helping you
//               reach your target audience efficiently and effectively.
//             </p>
//             <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center w-full">
//               <Link
//                 to="/get-quote"
//                 className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 rounded-lg px-8 py-4 font-bold shadow-xl ring-2 ring-yellow-100 hover:ring-yellow-300 focus:outline-none transition text-lg text-center"
//               >
//                 Get a Quote
//               </Link>
//               <Link
//                 to="/about"
//                 className="border-2 border-white text-white px-8 py-4 rounded-lg font-bold hover:bg-white/10 transition text-lg text-center"
//               >
//                 Learn More
//               </Link>
//             </div>
//           </motion.div>
//         </section>
//         {/* Stats */}
//         <section className="py-14 bg-white/0 max-w-6xl mx-auto px-4">
//           <div className="grid grid-cols-2 md:grid-cols-4 gap-7">
//             {stats.map((stat) => (
//               <motion.div
//                 key={stat.label}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//                 variants={fadeIn}
//                 className="bg-white/30 backdrop-blur-lg rounded-3xl p-10 text-center shadow-md transition hover:-translate-y-1 hover:shadow-yellow-200 group cursor-pointer"
//               >
//                 <span className="text-4xl font-extrabold text-yellow-400">
//                   <CountUp end={stat.value} />
//                 </span>
//                 <div className="text-xs uppercase tracking-widest mt-1 group-hover:text-blue-700">
//                   {stat.label}
//                 </div>
//                 <div className="text-[11px] mt-1 text-blue-600 font-semibold">
//                   {stat.trend}
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </section>
//         {/* About */}
//         <section className="py-24 bg-white">
//           <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
//             <motion.div
//               initial={{ opacity: 0, x: -30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.7 }}
//               viewport={{ once: true }}
//             >
//               <h2 className="text-3xl font-bold text-blue-900 mb-4">
//                 About Augere Strategies
//               </h2>
//               <p className="text-lg text-gray-700 mb-5">
//                 Augere Strategies  is India’s leading provider of{" "}
//                 <strong>
//                   data-driven lead generation, telecalling, and market research
//                 </strong>{" "}
//                 since 2020. Our Mumbai HQ backs brands PAN India—from funded
//                 tech pioneers to Fortune 500 MNCs—delivering reliable,
//                 compliance-ready solutions that convert insight to revenue.
//               </p>
//               <ul className="space-y-3">
//                 <li className="flex items-start">
//                   <svg
//                     className="w-5 h-5 text-yellow-500 mt-1 mr-2"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M5 13l4 4L19 7"
//                     />
//                   </svg>
//                   500M+ pan-India business records
//                 </li>
//                 <li className="flex items-start">
//                   <svg
//                     className="w-5 h-5 text-yellow-500 mt-1 mr-2"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M5 13l4 4L19 7"
//                     />
//                   </svg>
//                   Awarded top B2B telecalling provider, 2024
//                 </li>
//                 <li className="flex items-start">
//                   <svg
//                     className="w-5 h-5 text-yellow-500 mt-1 mr-2"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M5 13l4 4L19 7"
//                     />
//                   </svg>
//                   12+ years in B2B sales intelligence
//                 </li>
//               </ul>
//               <Link
//                 to="/about"
//                 className="inline-block mt-7 text-blue-700 font-semibold hover:text-yellow-500 hover:underline transition"
//               >
//                 Learn more About Us &rarr;
//               </Link>
//             </motion.div>
//             <motion.div
//               initial={{ opacity: 0, x: 30 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.7 }}
//               viewport={{ once: true }}
//               className="rounded-3xl shadow-xl overflow-hidden"
//             >
//               <img
//                 src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?auto=format&fit=crop&w=600&q=80"
//                 alt="Augere team at work"
//                 className="w-full object-cover max-h-[380px] min-h-[220px]"
//               />
//             </motion.div>
//           </div>
//         </section>
//         {/* Company Overview */}
//         <section className="py-20 bg-white">
//           <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">
//             <motion.div
//               initial={{ opacity: 0, x: -34 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.7 }}
//               viewport={{ once: true }}
//             >
//               <img
//                 src="https://images.unsplash.com/photo-1482062364825-616fd23b8fc1?auto=format&fit=crop&w=600&q=80"
//                 alt="Company workspace"
//                 className="rounded-3xl shadow-lg object-cover max-h-[330px]"
//               />
//             </motion.div>
//             <motion.div
//               initial={{ opacity: 0, x: 34 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.7 }}
//               viewport={{ once: true }}
//             >
//               <h2 className="text-3xl font-bold text-yellow-700 mb-4">
//                 Our Company at a Glance
//               </h2>
//               <p className="text-lg text-gray-700 mb-5">
//                 Born in Mumbai, we now operate across all Indian metros and
//                 Tier-II/III cities, with support and sales teams in New Delhi,
//                 Bangalore, and Pune. Our mission:{" "}
//                 <span className="text-blue-800 font-semibold">
//                   “Turning raw data into revenue for every Indian business.”
//                 </span>
//               </p>
//               <div className="grid grid-cols-2 gap-4 mt-6">
//                 <div>
//                   <div className="text-3xl font-bold text-blue-600">300+</div>
//                   <div className="text-base text-gray-600">Active Clients</div>
//                 </div>
//                 <div>
//                   <div className="text-3xl font-bold text-blue-600">15+</div>
//                   <div className="text-base text-gray-600">States Covered</div>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//         {/* --- Services with Modal --- */}
//         <section className="py-20 bg-gradient-to-br from-slate-100 via-white to-yellow-50">
//           <div className="max-w-7xl mx-auto px-6">
//             <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center">
//               Our Key Services
//             </h2>
//             <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
//               {services.map((service, idx) => (
//                 <motion.div
//                   key={service.title}
//                   initial={{ opacity: 0, y: 28 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: idx * 0.1, duration: 0.48 }}
//                   viewport={{ once: true }}
//                   whileHover={{ scale: 1.07, y: -4 }}
//                   className="bg-white/90 border border-yellow-100 rounded-2xl flex flex-col p-8 items-center text-center shadow hover:shadow-lg transition-all cursor-pointer"
//                 >
//                   <div className="mb-2 text-5xl">{service.icon}</div>
//                   <h3 className="text-lg font-extrabold mb-2 text-yellow-700">
//                     {service.title}
//                   </h3>
//                   <p className="text-gray-700/90 mb-4">{service.description}</p>
//                   <button
//                     className="text-blue-500 font-semibold hover:underline transition"
//                     onClick={() => setModalSvcIdx(idx)}
//                   >
//                     View Service
//                   </button>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//           <AnimatePresence>
//             {modalSvcIdx !== null && (
//               <motion.div
//                 className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
//                 initial="hidden"
//                 animate="visible"
//                 exit="hidden"
//                 variants={{
//                   visible: { opacity: 1, pointerEvents: "auto" },
//                   hidden: {
//                     opacity: 0,
//                     pointerEvents: "none",
//                     transition: { delay: 0.34 },
//                   },
//                 }}
//                 onClick={() => setModalSvcIdx(null)}
//               >
//                 <motion.div
//                   className="bg-white w-full max-w-lg rounded-3xl shadow-2xl p-9 relative mx-4"
//                   initial="hidden"
//                   animate="visible"
//                   exit="hidden"
//                   variants={{
//                     hidden: { opacity: 0, y: 70, scale: 0.96 },
//                     visible: {
//                       opacity: 1,
//                       y: 0,
//                       scale: 1,
//                       transition: { duration: 0.31, ease: [0.4, 0, 0.2, 1] },
//                     },
//                   }}
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <button
//                     className="absolute top-4 right-5 text-2xl text-blue-700 font-extrabold hover:text-yellow-600 transition"
//                     onClick={() => setModalSvcIdx(null)}
//                     aria-label="Close"
//                   >
//                     &times;
//                   </button>
//                   <div className="flex items-center gap-4 mb-4">
//                     <span className="text-3xl">
//                       {services[modalSvcIdx].icon}
//                     </span>
//                     <h3 className="text-2xl font-bold text-blue-900">
//                       {services[modalSvcIdx].title}
//                     </h3>
//                   </div>
//                   <p className="text-gray-700 mb-5">
//                     {services[modalSvcIdx].description}
//                   </p>
//                   <ul className="mb-7 space-y-2">
//                     {services[modalSvcIdx].bullets.map((item, i) => (
//                       <li key={i} className="flex items-start text-base">
//                         <svg
//                           className="mt-1 mr-2 w-5 h-5 text-yellow-500"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                           stroke="currentColor"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             d="M5 13l4 4L19 7"
//                           />
//                         </svg>
//                         <span>{item}</span>
//                       </li>
//                     ))}
//                   </ul>
//                   <div className="flex gap-4 mt-8">
//                     <Link
//                       to={services[modalSvcIdx].path}
//                       className="px-5 py-2 rounded-md bg-blue-600 text-white font-bold hover:bg-blue-700 transition"
//                     >
//                       Full Service Page
//                     </Link>
//                     <button
//                       onClick={() => setModalSvcIdx(null)}
//                       className="px-4 py-2 rounded-md border border-yellow-500 text-yellow-600 font-bold hover:bg-yellow-50 transition"
//                     >
//                       Close
//                     </button>
//                   </div>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </section>
//         {/* CLIENTS */}
//         <section className="bg-yellow-50 py-10">
//           <div className="max-w-5xl mx-auto px-6">
//             <h3 className="text-xl font-bold mb-7 text-center text-yellow-800">
//               Trusted by Indian Enterprises & Startups
//             </h3>
//             <div className="flex flex-wrap justify-center gap-7">
//               {clients.map((client, i) => (
//                 <motion.div
//                   key={client.name}
//                   initial={{ opacity: 0, scale: 0.9 }}
//                   whileInView={{ opacity: 1, scale: 1 }}
//                   transition={{ delay: i * 0.07 }}
//                   viewport={{ once: true }}
//                   className="flex flex-col items-center"
//                 >
//                   <img
//                     src={client.logo}
//                     alt={client.name}
//                     className="rounded-full w-20 h-20 border-4 border-yellow-200 shadow mb-2"
//                   />
//                   <div className="text-sm font-bold text-blue-700">
//                     {client.name}
//                   </div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//         {/* FEATURES ("Why Us") */}
//         <section className="py-16 bg-white">
//           <div className="max-w-7xl mx-auto px-6 text-center mb-11">
//             <h2 className="text-3xl font-bold mb-3 text-yellow-700">
//               Why Indian Businesses Choose Us
//             </h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               India-ready{" "}
//               <span className="text-yellow-600">
//                 platforms, expertise, compliance
//               </span>{" "}
//               — with heart and hustle.
//             </p>
//           </div>
//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 px-6">
//             {features.map((f, i) => (
//               <motion.div
//                 key={f.title}
//                 initial={{ opacity: 0, y: 40 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ delay: i * 0.1, duration: 0.5 }}
//                 className="bg-yellow-50 p-8 rounded-xl shadow hover:shadow-lg transition"
//               >
//                 <div className="text-yellow-700 font-bold text-lg mb-2">
//                   {String(i + 1).padStart(2, "0")}.
//                 </div>
//                 <h3 className="text-xl font-bold mb-3 text-blue-900">
//                   {f.title}
//                 </h3>
//                 <p className="text-gray-600">{f.description}</p>
//               </motion.div>
//             ))}
//           </div>
//         </section>
//         {/* TECHNOLOGIES */}
//         <section className="py-14 bg-gradient-to-r from-yellow-50 via-white to-blue-50">
//           <div className="max-w-6xl mx-auto px-6">
//             <h2 className="text-3xl font-bold text-yellow-800 mb-7 text-center">
//               Empowered by Indian-Ready Technologies
//             </h2>
//             <div className="grid md:grid-cols-4 gap-7">
//               {teComplex.map((t, i) => (
//                 <motion.div
//                   key={t.name}
//                   initial={{ opacity: 0, y: 30 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: i * 0.11 }}
//                   viewport={{ once: true }}
//                   className="rounded-lg bg-white p-7 shadow-sm flex flex-col items-center hover:bg-yellow-50 transition"
//                 >
//                   <div className="text-3xl mb-2">{t.icon}</div>
//                   <div className="text-lg font-bold mb-1 text-yellow-700">
//                     {t.name}
//                   </div>
//                   <div className="text-sm text-gray-600">{t.desc}</div>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//         {/* TESTIMONIALS */}
//         <section className="py-20 bg-blue-50">
//           <div className="max-w-5xl mx-auto px-6 text-center">
//             <h2 className="text-3xl font-bold text-yellow-800 mb-10">
//               Hear From Indian Entrepreneurs
//             </h2>
//             <div className="relative">
//               <AnimatePresence mode="wait">
//                 <motion.div
//                   key={testimonialIdx}
//                   initial={{ opacity: 0, x: -60 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   exit={{ opacity: 0, x: 50 }}
//                   transition={{ duration: 0.59 }}
//                   className="flex flex-col items-center"
//                 >
//                   <img
//                     src={testimonials[testimonialIdx].photo}
//                     alt={testimonials[testimonialIdx].name}
//                     className="w-20 h-20 rounded-full mx-auto mb-5 border-4 border-yellow-200 shadow"
//                   />
//                   <blockquote className="italic text-lg text-blue-800 mb-2 max-w-2xl">
//                     "{testimonials[testimonialIdx].quote}"
//                   </blockquote>
//                   <strong className="block text-yellow-800">
//                     {testimonials[testimonialIdx].name}
//                   </strong>
//                   <span className="text-blue-700 text-sm">
//                     {testimonials[testimonialIdx].role}
//                   </span>
//                 </motion.div>
//               </AnimatePresence>
//               <div className="mt-6 flex justify-center gap-3">
//                 {[0, 1].map((i) => (
//                   <button
//                     key={i}
//                     onClick={() => setTestimonialIdx(i)}
//                     className={`h-3 w-3 rounded-full border border-yellow-400 ${
//                       testimonialIdx === i ? "bg-yellow-500" : "bg-white"
//                     }`}
//                   ></button>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </section>
//         {/* TEAM */}
//         <section className="py-14 bg-gradient-to-br from-yellow-50 via-blue-50 to-white">
//           <div className="max-w-6xl mx-auto px-6">
//             <h2 className="text-3xl font-bold mb-8 text-yellow-800 text-center">
//               Meet Our Leadership
//             </h2>
//             <div className="flex flex-wrap justify-center gap-9">
//               {team.map((member, i) => (
//                 <motion.div
//                   key={member.name}
//                   initial={{ opacity: 0, y: 26 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   viewport={{ once: true }}
//                   transition={{ delay: i * 0.13 }}
//                   className="bg-white rounded-2xl shadow p-7 flex flex-col items-center w-80"
//                 >
//                   <img
//                     src={member.photo}
//                     alt={member.name}
//                     className="mb-3 w-20 h-20 rounded-full border-4 border-yellow-100"
//                   />
//                   <h4 className="text-blue-900 font-bold text-xl">
//                     {member.name}
//                   </h4>
//                   <span className="text-yellow-700">{member.role}</span>
//                   <p className="mt-3 text-gray-600 text-sm">{member.about}</p>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </section>
//         {/* FAQ */}
//         <section className="py-20 bg-gradient-to-br from-blue-50 via-yellow-50 to-white">
//           <div className="max-w-4xl mx-auto px-6">
//             <h2 className="text-3xl font-bold text-blue-900 mb-7 text-center">
//               Frequently Asked Questions
//             </h2>
//             <div className="space-y-5">
//               {faq.map((item, i) => (
//                 <div
//                   key={i}
//                   className={`border border-gray-200 bg-white rounded-lg shadow px-6 py-5 cursor-pointer transition group ${
//                     openFaq === i
//                       ? "ring-2 ring-yellow-400"
//                       : "hover:ring-1 hover:ring-yellow-200"
//                   }`}
//                   onClick={() => setOpenFaq(openFaq === i ? null : i)}
//                   tabIndex={0}
//                   aria-expanded={openFaq === i}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ")
//                       setOpenFaq(openFaq === i ? null : i);
//                   }}
//                 >
//                   <div className="flex items-center justify-between">
//                     <span className="font-semibold text-lg text-blue-900">
//                       {item.question}
//                     </span>
//                     <span className="ml-3 text-2xl text-yellow-500 transition-transform duration-200">
//                       {openFaq === i ? "-" : "+"}
//                     </span>
//                   </div>
//                   <AnimatePresence initial={false}>
//                     {openFaq === i && (
//                       <motion.div
//                         key={`faq-answer-${i}`}
//                         initial={{ height: 0, opacity: 0 }}
//                         animate={{ height: "auto", opacity: 1 }}
//                         exit={{ height: 0, opacity: 0 }}
//                         transition={{ duration: 0.27, ease: "easeInOut" }}
//                         className="overflow-hidden mt-3"
//                       >
//                         <div className="text-gray-700 text-base">
//                           {item.answer}
//                         </div>
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </section>
//         {/* FINAL CTA - No Phone Number */}
//         <section className="py-20 bg-gradient-to-r from-yellow-400 to-blue-800 text-white">
//           <div className="max-w-4xl mx-auto px-6 text-center">
//             <motion.h2
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               className="text-3xl font-bold mb-6"
//             >
//               Accelerate Your Business with Us
//             </motion.h2>
//             <motion.p
//               initial={{ opacity: 0 }}
//               whileInView={{ opacity: 1 }}
//               transition={{ delay: 0.19 }}
//               viewport={{ once: true }}
//               className="text-xl mb-8 max-w-2xl mx-auto"
//             >
//               Request your free growth consultation – our experts in Mumbai,
//               Delhi, and Bengaluru are ready to help!
//             </motion.p>
//             <motion.div
//               initial={{ opacity: 0, scale: 0.98 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               transition={{ delay: 0.15 }}
//               className="flex justify-center"
//             >
//               <Link
//                 to="/contact"
//                 className="bg-white text-yellow-700 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition shadow-lg hover:shadow-xl"
//               >
//                 Contact Us
//               </Link>
//             </motion.div>
//           </div>
//         </section>
//       </div>
//       <CookieBanner />
//     </>
//   );
// };

// export default Home;

import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import CookieBanner from "../components/CookieBanner";
import Indian from "./images/indian.jpg";

// Import client logos
import logo1 from "./images/logo.svg";
import logo2 from "./images/logo2.png";
import logo3 from "./images/logo3.png";
import logo4 from "./images/logo4.png";
import logo5 from "./images/logo5.png";
import logo6 from "./images/logo6.png";

// -- Constants/Assets --
const HERO_IMAGE =
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80";
const TEAM_IMAGES = [
  "https://randomuser.me/api/portraits/men/33.jpg",
  "https://randomuser.me/api/portraits/women/31.jpg",
  "https://randomuser.me/api/portraits/men/20.jpg",
];
const TESTIMONIAL_IMAGES = [
  "https://randomuser.me/api/portraits/men/13.jpg",
  "https://randomuser.me/api/portraits/women/12.jpg",
];

// -- Helper: Animated count up --
const CountUp = ({ end, prefix = "", duration = 1.0 }) => {
  const [val, setVal] = useState(0);
  useState(() => {
    let start = 0,
      curFrame = 0;
    const fps = 30,
      totalFrames = duration * fps;
    const endNum =
      typeof end === "string" ? Number(end.replace(/[^0-9]/g, "")) : end;
    const inc = endNum / totalFrames;
    const interval = setInterval(() => {
      curFrame += 1;
      start += inc;
      if (curFrame >= totalFrames) {
        setVal(end);
        clearInterval(interval);
      } else
        setVal(prefix + Math.floor(start) + (end.includes("k") ? "k+" : "+"));
    }, 1000 / fps);
    return () => clearInterval(interval);
  }, []);
  return <span>{val}</span>;
};

// --- Data arrays ---
const stats = [
  { value: "5+", label: "Country", trend: "Country Served" },
  { value: "13+", label: "Happy Clients", trend: "95% Retention" },
  { value: "5+", label: "Years Experience", trend: "Since 2020" },
];

const services = [
  {
    title: "Telecalling",
    icon: "📞",
    path: "/telecallingservices",
    description:
      "Targeted campaigns in English, French, German, Hindi, Punjabi, Marathi, Gujrati and more",
    bullets: [
      "Personalized scripts & follow-ups",
      "B2B & B2C vertical dialing",
      "Voice & IVR analytics dashboard",
      "Multilingual & regional specialization",
      "Strict GDPR/DPDP compliance",
    ],
  },
  {
    title: "Lead Generation",
    icon: "🚀",
    path: "/leadgenration",
    description:
      "Blending local insights & digital for superior Indian conversion.",
    bullets: [
      "Custom MCA verified prospect lists",
      "Outbound, digital & referral campaigns",
      "Decision-maker targeting via digital tools",
      "High-intent inbound lead management",
      "Conversion optimization & reporting",
    ],
  },
  {
    title: "Data Build",
    icon: "📊",
    path: "/dataBuildservices",
    description:
      "Enrich business lists with verified KYC,  & company metadata.",
    bullets: [
      "Dual-verified B2B datasets by vertical",
      "Technographics & firmographics data",
      "Automated deduplication/cleansing",
      "Seamless CRM/data warehouse integration",
      "Full DPDP, GDPR, RBI overlays",
    ],
  },
  {
    title: "Customer Support",
    icon: "👥",
    path: "/customersupportservices",
    description:
      "24/7 & multilingual—serving Global businesses across time zones.",
    bullets: [
      "Omnichannel (voice, chat, WhatsApp, email)",
      "Flexible coverage—business hours to 24/7",
      "Customer CSAT/NPS dashboards",
      "Industry-customized response flows",
      "Rapid deployment, best-in-class training",
    ],
  },
  {
    title: "Market Research",
    icon: "📋",
    path: "/Webinarregistrationservices",
    description: "On-ground and online surveys, data-driven strategy.",
    bullets: [
      "Digital/offline survey management",
      "Analytics by sector & region",
      "Focus group & behavioral studies",
      "End-to-end data-to-report delivery",
    ],
  },
];

const clients = [
  { name: "", logo: logo1 },
  { name: "", logo: logo2 },
  { name: "", logo: logo3 },
  { name: "", logo: logo4 },
  { name: "", logo: logo5 },
  { name: "", logo: logo6 },
];

const features = [
  {
    title: "Bharat Expertise",
    description:
      "Decades in Indian B2B sales enablement & database compliance.",
  },
  {
    title: "Data Accuracy",
    description: "Dual-verified, checked info, 99%+ accuracy guaranteed.",
  },
  {
    title: "Regional Coverage",
    description:
      "Urban & rural coverage from metros to Tier-II/III Indian cities.",
  },
  {
    title: "Compliance",
    description:
      "STRICT privacy - fully adheres to India's DPDP, GDPR, and RBI regs.",
  },
];

const testimonials = [
  {
    quote:
      "Augere's multilingual telecalling helped us tap SME clients across Pune  Fantastic reliability and reporting.",
    name: "Amit Sharma",
    role: "Head of Business, Bajaj",
    photo: TESTIMONIAL_IMAGES[0],
  },
  {
    quote:
      "We saw conversion rates improve 50%. The localized lead lists are best in the market.",
    name: "Priya Singh",
    role: "Sales Ops, TCS",
    photo: TESTIMONIAL_IMAGES[1],
  },
];

const teComplex = [
  {
    name: "AI Data Tools",
    desc: "Smart matching & enrichment, built for Indian business formats.",
    icon: "🤖",
  },
  {
    name: "Cloud Secure",
    desc: "All India AWS Data Regions, instant scalable access.",
    icon: "☁️",
  },
  {
    name: "CRM Integration",
    desc: "Seamless with Zoho, Freshsales, Salesforce, Hubspot.",
    icon: "🔗",
  },
  {
    name: "WhatsApp APIs",
    desc: "Outreach & support directly via WhatsApp Business.",
    icon: "📱",
  },
];

const team = [
  // {
  //   name: "Rohan Malhotra",
  //   role: "Founder & CEO",
  //   about: "Visionary with 16yrs in Indian SaaS & BFSI.",
  //   photo: TEAM_IMAGES[0],
  // },
  // {
  //   name: "Priya Venkatesh",
  //   role: "Head - Data Ops",
  //   about: "Leads cross-India QA & analytics. IIM alum.",
  //   photo: TEAM_IMAGES[1],
  // },
  // {
  //   name: "Anil Kumar",
  //   role: "Chief Growth Officer",
  //   about: "Spearheads client campaigns, ex-Zoho.",
  //   photo: TEAM_IMAGES[2],
  // },
];

const faq = [
  {
    question: "What industries do you serve?",
    answer:
      "We serve BFSI, SaaS, EdTech, D2C, Manufacturing, Healthcare, and more—covering both startups and large enterprises across India.",
  },
  {
    question: "How can we trust you?",
    answer:
      "We invoice you post successful delivery of the campaign/project, no advance payments. ",
  },
  {
    question: "How accurate is your data?",
    answer:
      "We guarantee 99%+ accuracy due to dual-checks, MCA validation, and regular refreshes. We also honor opt-outs as per DPDP.",
  },
  {
    question: "What Languages do you support?",
    answer:
      "Absolutely! Our teams operate in English, French, German, Hindi, Punjabi, Marathi, Gujrati and more.",
  },

  {
    question: "Do you handle compliance and data privacy?",
    answer:
      "Yes. We're fully compliant with India's DPDP Act, RBI, and GDPR, and maintain detailed audit trails for all datasets.",
  },
  {
    question: "What is the onboarding process like?",
    answer:
      "After an initial consult, you get a custom plan and demo. We onboard and integrate within 3–10 days depending on scale.",
  },
];

const fadeIn = {
  hidden: { opacity: 0, y: 38 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.77 } },
};

const Home = () => {
  const [testimonialIdx, setTestimonialIdx] = useState(0);
  const [openFaq, setOpenFaq] = useState(null);
  const [modalSvcIdx, setModalSvcIdx] = useState(null);

  return (
    <>
      <div className="font-sans text-gray-800 bg-gradient-to-br from-blue-900 to-indigo-950 min-h-screen">
        {/* HERO SECTION - Visually Enhanced & Responsive */}
        <section className="relative min-h-[80vh] flex items-center justify-center bg-black overflow-hidden mb-7">
          {/* Background Image */}
          <img
            src={HERO_IMAGE}
            alt="Mumbai Skyline"
            className="absolute inset-0 w-full h-full object-cover z-0"
            style={{ filter: "brightness(0.5)" }} // Stronger dark overlay for visibility
          />

          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-tr from-black/80 via-blue-900/70 to-yellow-200/20 z-10"></div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 45 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="relative z-20 w-full max-w-3xl px-6 py-10 md:px-10 md:py-16 rounded-3xl 
               bg-black/40 backdrop-blur-xl shadow-2xl border border-white/20 flex flex-col items-center text-center"
          >
            {/* Decorative Circle */}
            <div className="absolute top-8 left-8 w-12 h-12 bg-yellow-300 rounded-full opacity-30 blur-xl"></div>

            {/* Tagline */}
            <span
              className="bg-yellow-400/20 px-6 py-2 rounded-full text-sm md:text-lg font-semibold 
                     text-yellow-200 border border-yellow-300/40 shadow mb-6 tracking-wide italic"
            >
              Backed by decades of expertise
            </span>

            {/* Main Heading */}
            <h1
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight 
                   text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-white to-blue-200 drop-shadow-md"
            >
              <span className="inline-block pb-0.5 border-b-4 border-yellow-400">
                India's Boldest
              </span>
              <br className="hidden md:block" />
              Lead Generation & Data Building Team
            </h1>

            {/* Subheading */}
            <p className="text-base sm:text-lg md:text-xl text-gray-100 mt-6 mb-4 font-medium max-w-2xl">
              Welcome to{" "}
              <span className="text-yellow-300 font-bold">
                Augere Strategies
              </span>{" "}
              — your trusted partner for{" "}
              <span className="text-blue-200 font-bold">
                B2B lead generation
              </span>
              and database solutions.
            </p>

            <p className="text-sm sm:text-base md:text-lg text-gray-200 mb-8 max-w-3xl">
              Our mission is to empower
              <span className="text-yellow-300 font-semibold">
                {" "}
                event organizers, media, IT, publishing, and financial services
                companies{" "}
              </span>
              with high-quality, accurate, and comprehensive data.
            </p>

            {/* Buttons
            <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center">
              <Link
                to="/contact"
                className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 rounded-lg px-8 py-4 font-bold shadow-xl 
                   hover:shadow-2xl transition text-lg"
              >
                Get a Quote
              </Link>
              <Link
                to="/about"
                className="border-2 border-yellow-300 text-yellow-200 px-8 py-4 rounded-lg font-bold 
                   hover:bg-yellow-300 hover:text-blue-900 transition text-lg"
              >
                Learn More
              </Link>
            </div> */}

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center">
              <a
                href="/contact"
                className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 rounded-lg px-8 py-4 font-bold shadow-xl 
               hover:shadow-2xl transition text-lg"
              >
                Get a Quote
              </a>

              <a
                href="/about"
                className="border-2 border-yellow-300 text-yellow-200 px-8 py-4 rounded-lg font-bold 
               hover:bg-yellow-300 hover:text-blue-900 transition text-lg"
              >
                Learn More
              </a>
            </div>
          </motion.div>
        </section>

        {/* Stats */}
        {/* <section className="py-14 bg-white/0 max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-7">
            {stats.map((stat) => (
              <motion.div
                key={stat.label}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeIn}
                className="bg-white/30 backdrop-blur-lg rounded-3xl p-10 text-center shadow-md transition hover:-translate-y-1 hover:shadow-yellow-200 group cursor-pointer"
              >
                <span className="text-4xl font-extrabold text-yellow-400">
                  <CountUp end={stat.value} />
                </span>
                <div className="text-xs uppercase tracking-widest mt-1 group-hover:text-blue-700">
                  {stat.label}
                </div>
                <div className="text-[11px] mt-1 text-blue-600 font-semibold">
                  {stat.trend}
                </div>
              </motion.div>
            ))}
          </div>
        </section> */}

        <section className="py-14 bg-white/0 max-w-6xl mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-7">
            {stats.map((stat) => (
              <motion.div
                key={stat.label}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeIn}
                className="bg-white/30 backdrop-blur-lg rounded-3xl p-10 text-center shadow-md transition hover:-translate-y-1 hover:shadow-yellow-200 group cursor-pointer w-full sm:w-[calc(50%-14px)] md:w-[calc(25%-21px)] max-w-[250px]"
              >
                <span className="text-4xl font-extrabold text-yellow-400">
                  <CountUp end={stat.value} />
                </span>
                <div className="text-xs uppercase tracking-widest mt-1 group-hover:text-blue-700">
                  {stat.label}
                </div>
                <div className="text-[11px] mt-1 text-blue-600 font-semibold">
                  {stat.trend}
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* About */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-blue-900 mb-4">
                About Augere Strategies
              </h2>
              <p className="text-lg text-gray-700 mb-5">
                Augere Strategies is India's leading provider of{" "}
                <strong>
                  data-driven lead generation, telecalling, and market research
                </strong>{" "}
                since 2020. Our Mumbai HQ backs brands Across Europe, North
                America, U.A.E and PAN India—from funded tech pioneers to
                Fortune 500 MNCs—delivering reliable, compliance-ready solutions
                that convert insight to revenue.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-yellow-500 mt-1 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  500M+ business records
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-yellow-500 mt-1 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  Awarded top B2B telecalling provider, 2024
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-yellow-500 mt-1 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  12+ years in B2B sales intelligence
                </li>
              </ul>
              {/* <Link
                to="/about"
                className="inline-block mt-7 text-blue-700 font-semibold hover:text-yellow-500 hover:underline transition"
              >
                Learn more About Us &rarr;
              </Link> */}
              <a
                href="/about"
                className="inline-block mt-7 text-blue-700 font-semibold hover:text-yellow-500 hover:underline transition"
              >
                Learn more About Us &rarr;
              </a>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
              className="rounded-3xl shadow-xl overflow-hidden"
            >
              <img
                src={Indian}
                alt="Augere team at work"
                className="w-full object-cover max-h-[380px] min-h-[220px]"
              />
            </motion.div>
          </div>
        </section>

        {/* Company Overview */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">
            <motion.div
              initial={{ opacity: 0, x: -34 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <img
                src="https://images.unsplash.com/photo-1482062364825-616fd23b8fc1?auto=format&fit=crop&w=600&q=80"
                alt="Company workspace"
                className="rounded-3xl shadow-lg object-cover max-h-[330px]"
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 34 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-yellow-700 mb-4">
                Our Company at a Glance
              </h2>
              <p className="text-lg text-gray-700 mb-5">
                Born in Mumbai, we now operate across all Indian metros and
                Tier-II/III cities, with support and sales teams in and Pune.
                Our mission:{" "}
                <span className="text-blue-800 font-semibold">
                  "Turning raw data into revenue for every Indian business."
                </span>
              </p>
              <div className="grid grid-cols-2 gap-4 mt-6">
                <div>
                  <div className="text-3xl font-bold text-blue-600">13+</div>
                  <div className="text-base text-gray-600">Active Clients</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-blue-600">5+</div>
                  <div className="text-base text-gray-600">
                    Countries Covered
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* --- Services with Modal --- */}
        <section className="py-20 bg-gradient-to-br from-slate-100 via-white to-yellow-50">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-blue-900 mb-10 text-center">
              Our Key Services
            </h2>
            <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8">
              {services.map((service, idx) => (
                <motion.div
                  key={service.title}
                  initial={{ opacity: 0, y: 28 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1, duration: 0.48 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.07, y: -4 }}
                  className="bg-white/90 border border-yellow-100 rounded-2xl flex flex-col p-8 items-center text-center shadow hover:shadow-lg transition-all cursor-pointer"
                >
                  <div className="mb-2 text-5xl">{service.icon}</div>
                  <h3 className="text-lg font-extrabold mb-2 text-yellow-700">
                    {service.title}
                  </h3>
                  <p className="text-gray-700/90 mb-4">{service.description}</p>
                  <button
                    className="text-blue-500 font-semibold hover:underline transition"
                    onClick={() => setModalSvcIdx(idx)}
                  >
                    View Service
                  </button>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Modal */}
          <AnimatePresence>
            {modalSvcIdx !== null && (
              <motion.div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
                initial="hidden"
                animate="visible"
                exit="hidden"
                variants={{
                  visible: { opacity: 1, pointerEvents: "auto" },
                  hidden: {
                    opacity: 0,
                    pointerEvents: "none",
                    transition: { delay: 0.34 },
                  },
                }}
                onClick={() => setModalSvcIdx(null)}
              >
                <motion.div
                  className="bg-white w-full max-w-lg rounded-3xl shadow-2xl p-9 relative mx-4"
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={{
                    hidden: { opacity: 0, y: 70, scale: 0.96 },
                    visible: {
                      opacity: 1,
                      y: 0,
                      scale: 1,
                      transition: { duration: 0.31, ease: [0.4, 0, 0.2, 1] },
                    },
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="absolute top-4 right-5 text-2xl text-blue-700 font-extrabold hover:text-yellow-600 transition"
                    onClick={() => setModalSvcIdx(null)}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                  <div className="flex items-center gap-4 mb-4">
                    <span className="text-3xl">
                      {services[modalSvcIdx].icon}
                    </span>
                    <h3 className="text-2xl font-bold text-blue-900">
                      {services[modalSvcIdx].title}
                    </h3>
                  </div>
                  <p className="text-gray-700 mb-5">
                    {services[modalSvcIdx].description}
                  </p>
                  <ul className="mb-7 space-y-2">
                    {services[modalSvcIdx].bullets.map((item, i) => (
                      <li key={i} className="flex items-start text-base">
                        <svg
                          className="mt-1 mr-2 w-5 h-5 text-yellow-500"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="flex gap-4 mt-8">
                    <Link
                      to={services[modalSvcIdx].path}
                      className="px-5 py-2 rounded-md bg-blue-600 text-white font-bold hover:bg-blue-700 transition"
                    >
                      Full Service Page
                    </Link>
                    <button
                      onClick={() => setModalSvcIdx(null)}
                      className="px-4 py-2 rounded-md border border-yellow-500 text-yellow-600 font-bold hover:bg-yellow-50 transition"
                    >
                      Close
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </section>

        {/* CLIENTS - Updated with logo images */}
        <section className="bg-yellow-50 py-10">
          <div className="max-w-5xl mx-auto px-6">
            <h3 className="text-xl font-bold mb-7 text-center text-yellow-800">
              Trusted by Indian Enterprises & Startups
            </h3>
            <div className="flex flex-wrap justify-center gap-7">
              {clients.map((client, i) => (
                <motion.div
                  key={client.name}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: i * 0.07 }}
                  viewport={{ once: true }}
                  className="flex flex-col items-center"
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="w-32 h-20 object-contain mb-2"
                  />
                  <div className="text-sm font-bold text-blue-700">
                    {client.name}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* FEATURES ("Why Us") */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6 text-center mb-11">
            <h2 className="text-3xl font-bold mb-3 text-yellow-700">
              Why Indian Businesses Choose Us
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              India-ready{" "}
              <span className="text-yellow-600">
                platforms, expertise, compliance
              </span>{" "}
              — with heart and hustle.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 px-6">
            {features.map((f, i) => (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                className="bg-yellow-50 p-8 rounded-xl shadow hover:shadow-lg transition"
              >
                <div className="text-yellow-700 font-bold text-lg mb-2">
                  {String(i + 1).padStart(2, "0")}.
                </div>
                <h3 className="text-xl font-bold mb-3 text-blue-900">
                  {f.title}
                </h3>
                <p className="text-gray-600">{f.description}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* TECHNOLOGIES */}
        {/* <section className="py-14 bg-gradient-to-r from-yellow-50 via-white to-blue-50">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-yellow-800 mb-7 text-center">
              Empowered by Indian-Ready Technologies
            </h2>
            <div className="grid md:grid-cols-4 gap-7">
              {teComplex.map((t, i) => (
                <motion.div
                  key={t.name}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.11 }}
                  viewport={{ once: true }}
                  className="rounded-lg bg-white p-7 shadow-sm flex flex-col items-center hover:bg-yellow-50 transition"
                >
                  <div className="text-3xl mb-2">{t.icon}</div>
                  <div className="text-lg font-bold mb-1 text-yellow-700">
                    {t.name}
                  </div>
                  <div className="text-sm text-gray-600">{t.desc}</div>
                </motion.div>
              ))}
            </div>
          </div>
        </section> */}

        {/* TESTIMONIALS
        <section className="py-20 bg-blue-50">
          <div className="max-w-5xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-yellow-800 mb-10">
              Hear From Indian Entrepreneurs
            </h2>
            <div className="relative">
              <AnimatePresence mode="wait">
                <motion.div
                  key={testimonialIdx}
                  initial={{ opacity: 0, x: -60 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 50 }}
                  transition={{ duration: 0.59 }}
                  className="flex flex-col items-center"
                >
                  <img
                    src={testimonials[testimonialIdx].photo}
                    alt={testimonials[testimonialIdx].name}
                    className="w-20 h-20 rounded-full mx-auto mb-5 border-4 border-yellow-200 shadow"
                  />
                  <blockquote className="italic text-lg text-blue-800 mb-2 max-w-2xl">
                    "{testimonials[testimonialIdx].quote}"
                  </blockquote>
                  <strong className="block text-yellow-800">
                    {testimonials[testimonialIdx].name}
                  </strong>
                  <span className="text-blue-700 text-sm">
                    {testimonials[testimonialIdx].role}
                  </span>
                </motion.div>
              </AnimatePresence>
              <div className="mt-6 flex justify-center gap-3">
                {[0, 1].map((i) => (
                  <button
                    key={i}
                    onClick={() => setTestimonialIdx(i)}
                    className={`h-3 w-3 rounded-full border border-yellow-400 ${
                      testimonialIdx === i ? "bg-yellow-500" : "bg-white"
                    }`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </section>

 */}

        <section className="py-16 bg-white">
          <div className="container mx-auto px-6 md:px-12">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
              Why Partner with Augere Conversion?
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {/* Left Column */}
              <div className="space-y-6">
                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Commitment to Quality & Satisfaction
                  </h3>
                  <p className="text-gray-600 ml-6">
                    We place quality at the core of everything we do, ensuring
                    complete client satisfaction before, during, and after every
                    campaign.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Pay After Performance
                  </h3>
                  <p className="text-gray-600 ml-6">
                    With flexible post-performance billing, you only pay once
                    your campaign delivers results—building confidence and trust
                    in our partnership.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Tailored Solutions for Every Client
                  </h3>
                  <p className="text-gray-600 ml-6">
                    No two businesses are alike. We design customized solutions
                    that address your unique requirements and deliver measurable
                    outcomes.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Global Reach with Multilingual Support
                  </h3>
                  <p className="text-gray-600 ml-6">
                    Engage diverse markets with ease—our multilingual services
                    help you connect with audiences across geographies.
                  </p>
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-6">
                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Data-Driven Insights
                  </h3>
                  <p className="text-gray-600 ml-6">
                    We go beyond execution, offering actionable analytics and
                    recommendations to guide smarter decisions for future
                    campaigns.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Constant Innovation
                  </h3>
                  <p className="text-gray-600 ml-6">
                    Our strategies evolve continuously, ensuring you stay ahead
                    and connect with the right audience effectively.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Extended Sales Support
                  </h3>
                  <p className="text-gray-600 ml-6">
                    We cover gaps that traditional SDR or BDR teams may miss,
                    boosting the overall impact of your outreach efforts.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Fast & Reliable Execution
                  </h3>
                  <p className="text-gray-600 ml-6">
                    We value time and deliver quick turnarounds without ever
                    compromising quality.
                  </p>
                </div>

                <div>
                  <h3 className="font-semibold text-lg">
                    <span className="text-blue-600 mr-2">➤</span>
                    Pipeline Growth as the True Success Metric
                  </h3>
                  <p className="text-gray-600 ml-6">
                    For us, success is defined by one thing—expanding your sales
                    pipeline while optimizing the investment needed to achieve
                    it.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section className="py-20 bg-blue-50">
          <div className="max-w-5xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-bold text-yellow-800 mb-10">
              Hear From Our Clients
            </h2>
            <div className="relative">
              <AnimatePresence mode="wait">
                <motion.div
                  key={testimonialIdx}
                  initial={{ opacity: 0, x: -60 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 50 }}
                  transition={{ duration: 0.59 }}
                  className="flex flex-col items-center"
                >
                  {/* Replaced image with initial avatar */}
                  <div className="w-20 h-20 rounded-full mx-auto mb-5 border-4 border-yellow-200 shadow bg-yellow-500 flex items-center justify-center">
                    <span className="text-white text-2xl font-bold">
                      {testimonials[testimonialIdx].name.charAt(0)}
                    </span>
                  </div>
                  <blockquote className="italic text-lg text-blue-800 mb-2 max-w-2xl">
                    "{testimonials[testimonialIdx].quote}"
                  </blockquote>
                  <strong className="block text-yellow-800">
                    {testimonials[testimonialIdx].name}
                  </strong>
                  <span className="text-blue-700 text-sm">
                    {testimonials[testimonialIdx].role}
                  </span>
                </motion.div>
              </AnimatePresence>
              <div className="mt-6 flex justify-center gap-3">
                {[0, 1].map((i) => (
                  <button
                    key={i}
                    onClick={() => setTestimonialIdx(i)}
                    className={`h-3 w-3 rounded-full border border-yellow-400 ${
                      testimonialIdx === i ? "bg-yellow-500" : "bg-white"
                    }`}
                  ></button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* TEAM */}
        {/* <section className="py-14 bg-gradient-to-br from-yellow-50 via-blue-50 to-white">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold mb-8 text-yellow-800 text-center">
              Meet Our Leadership
            </h2>
            <div className="flex flex-wrap justify-center gap-9">
              {team.map((member, i) => (
                <motion.div
                  key={member.name}
                  initial={{ opacity: 0, y: 26 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.13 }}
                  className="bg-white rounded-2xl shadow p-7 flex flex-col items-center w-80"
                >
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="mb-3 w-20 h-20 rounded-full border-4 border-yellow-100"
                  />
                  <h4 className="text-blue-900 font-bold text-xl">
                    {member.name}
                  </h4>
                  <span className="text-yellow-700">{member.role}</span>
                  <p className="mt-3 text-gray-600 text-sm">{member.about}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section> */}

        {/* <section className="py-14 bg-gradient-to-br from-yellow-50 via-blue-50 to-white">
          <div className="max-w-6xl mx-auto px-6">
            <h2 className="text-3xl font-bold mb-8 text-yellow-800 text-center">
              Meet Our Leadership
            </h2>
            <div className="flex flex-wrap justify-center gap-9">
              {team.map((member, i) => (
                <motion.div
                  key={member.name}
                  initial={{ opacity: 0, y: 26 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.13 }}
                  className="bg-white rounded-2xl shadow p-7 flex flex-col items-center w-80"
                >
                  <div className="mb-3 w-20 h-20 rounded-full border-4 border-yellow-100 bg-blue-100 flex items-center justify-center">
                    <span className="text-2xl">👤</span>
                  </div>
                  <h4 className="text-blue-900 font-bold text-xl">
                    {member.name}
                  </h4>
                  <span className="text-yellow-700">{member.role}</span>
                  <p className="mt-3 text-gray-600 text-sm text-center">
                    {member.about}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </section> */}

        <section className="py-14 bg-gradient-to-br from-yellow-50 via-blue-50 to-white">
          <div className="max-w-6xl mx-auto px-6">
            {/* <h2 className="text-3xl font-bold mb-8 text-yellow-800 text-center">
              Meet Our Leadership
            </h2> */}
            <div className="flex flex-wrap justify-center gap-9">
              {team.map((member, i) => (
                <motion.div
                  key={member.name}
                  initial={{ opacity: 0, y: 26 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.13 }}
                  className="bg-white rounded-2xl shadow p-7 flex flex-col items-center w-80"
                >
                  <h4 className="text-blue-900 font-bold text-xl">
                    {member.name}
                  </h4>
                  <span className="text-yellow-700">{member.role}</span>
                  <p className="mt-3 text-gray-600 text-sm text-center">
                    {member.about}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
        {/* FAQ */}
        <section className="py-20 bg-gradient-to-br from-blue-50 via-yellow-50 to-white">
          <div className="max-w-4xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-blue-900 mb-7 text-center">
              Frequently Asked Questions
            </h2>
            <div className="space-y-5">
              {faq.map((item, i) => (
                <div
                  key={i}
                  className={`border border-gray-200 bg-white rounded-lg shadow px-6 py-5 cursor-pointer transition group ${
                    openFaq === i
                      ? "ring-2 ring-yellow-400"
                      : "hover:ring-1 hover:ring-yellow-200"
                  }`}
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  tabIndex={0}
                  aria-expanded={openFaq === i}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      setOpenFaq(openFaq === i ? null : i);
                  }}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-lg text-blue-900">
                      {item.question}
                    </span>
                    <span className="ml-3 text-2xl text-yellow-500 transition-transform duration-200">
                      {openFaq === i ? "-" : "+"}
                    </span>
                  </div>
                  <AnimatePresence initial={false}>
                    {openFaq === i && (
                      <motion.div
                        key={`faq-answer-${i}`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.27, ease: "easeInOut" }}
                        className="overflow-hidden mt-3"
                      >
                        <div className="text-gray-700 text-base">
                          {item.answer}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FINAL CTA - No Phone Number */}
        <section className="py-20 bg-gradient-to-r from-yellow-400 to-blue-800 text-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-3xl font-bold mb-6"
            >
              Accelerate Your Business with Us
            </motion.h2>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.19 }}
              viewport={{ once: true }}
              className="text-xl mb-8 max-w-2xl mx-auto"
            >
              Request your free growth consultation – our experts in Mumbai,
              Delhi, and Bengaluru are ready to help!
            </motion.p>
            <motion.div
              initial={{ opacity: 0, scale: 0.98 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.15 }}
              className="flex justify-center"
            >
              {/* <Link
                to="/contact"
                className="bg-white text-yellow-700 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition shadow-lg hover:shadow-xl"
              >
                Contact Us
              </Link> */}

              <a
                href="/contact"
                className="bg-white text-yellow-700 px-8 py-3 rounded-lg font-bold hover:bg-gray-100 transition shadow-lg hover:shadow-xl"
              >
                Contact
              </a>
            </motion.div>
          </div>
        </section>
      </div>
      <CookieBanner />
    </>
  );
};

export default Home;
